import { render, staticRenderFns } from "./advanceHeadingSettingsComponent.vue?vue&type=template&id=5b3afa20"
import script from "./advanceHeadingSettingsComponent.vue?vue&type=script&lang=js"
export * from "./advanceHeadingSettingsComponent.vue?vue&type=script&lang=js"
import style0 from "./advanceHeadingSettingsComponent.vue?vue&type=style&index=0&id=5b3afa20&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports